import React from 'react';
import SiteHeader from './SiteHeader';
import SiteHero from './SiteHero';
import SiteServicos from './SiteServicos';
import SiteCTA from './SiteCTA';
import SiteFooter from './SiteFooter';

export default function SiteEmpresa() {
  return (
    <div className="min-h-screen bg-gestao-background text-slate-800">
      <SiteHeader />
      <main>
        <SiteHero />
        <SiteServicos />
        <SiteCTA />
        <SiteFooter />
      </main>
    </div>
  );
}
